<template>
    <v-dialog v-model="show" max-width="500" scrollable overlay-color="#000" overlay-opacity="0.8" :transition="phoneOnly ? 'slide-y-transition' : 'dialog-transition'" :fullscreen="phoneOnly" :fluid="phoneOnly">
        <v-card>
            <template v-if="questionDetails">
                <v-card-title class="d-flex justify-space-between mb-3">
                    <div>تفاصيل السؤال #{{questionDetails.id}}</div>
                    <div style="margin-left: -10px">
                        <v-btn icon color="muted" @click="show = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-subtitle>
                    <div class="d-flex ">
                        <v-chip v-if="questionDetails.category" color="grey lighten-4" :key="questionDetails.category.id" small label depressed class="me-1">
                            <v-icon small color="blue darken-2" left class="me-2">mdi-folder</v-icon>
                            <span>{{questionDetails.category.name}}</span>
                        </v-chip>


                        <v-chip v-if="questionDetails.page_number" color="grey lighten-4" small label class="me-1 px-2">
                            <v-icon size="15" class="me-1">mdi-file-outline</v-icon>
                            <span>صـ {{questionDetails.page_number}}</span>
                        </v-chip>
                        <v-chip v-if="questionDetails.question_number" color="grey lighten-4" small label class="me-1 px-2">
                            <!-- <v-icon size="15" class="me-1">mdi-file-outline</v-icon> -->
                            <span>س {{questionDetails.question_number}}</span>
                        </v-chip>
                    </div>
                </v-card-subtitle>
                <v-card-text>
                    <v-card v-if="questionDetails.text" text class="bordered grey lighten-4" flat>
                        <v-card-text style="font-size: 15px; line-height: 1.6; whitespace: pre-wrap;">
                            <div class="strong-text--text">
                                {{questionDetails.text}}
                            </div>
                        </v-card-text>
                    </v-card>
                    <div v-if="questionDetails.image_url" class="my-4 bordered pa-3">
                        <v-img contain :src="questionDetails.image_url" rounded></v-img>
                    </div>
                    <!-- <v-divider class="my-2"></v-divider> -->
                    <div>
                        <v-list class="transparent pa-0 ma-0">
                            <v-subheader class="mt-5 mb-1 ps-2" style="height: auto">اﻹجابة</v-subheader>

                            <div v-if="questionDetails.answer_text" class="pa-3 my-4 bordered">{{questionDetails.answer_text}}</div>
                            <div v-if="questionDetails.answer_image" class="my-4 bordered pa-3">
                                <v-img contain :src="questionDetails.answer_image" rounded></v-img>
                            </div>
                            <div v-if="questionDetails.answer_audio" class="bordered rounded-lg pa-1 my-4">
                                <audio-player v-if="show" :url="questionDetails.answer_audio" />
                            </div>
                        </v-list>
                    </div>

                    <div v-if="questionDetails.teacher">
                        <v-divider class="my-3"></v-divider>

                        <div class="d-flex align-center details-text">
                            <span class="me-2">تم اﻹضافة بواسطة المعلم: </span>
                            <v-avatar tile size="20" class="me-1">
                                <v-img :src="questionDetails.teacher.avatar"></v-img>
                            </v-avatar>
                            <span class="strong-text--text">{{questionDetails.teacher.name}}</span>
                        </div>
                    </div>
                </v-card-text>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import AudioPlayer from '@/components/custom/audio-player.vue'

export default {
    props: {
        value: {},
        questionDetails: {},
    },
    components: {AudioPlayer},
    data(){
        return {
            show: false,
        }
    },
    computed: {
        ...GlobalComputed,

    },
    watch: {
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        },
    },
    methods: {
        ...GlobalMethods,
    },
    mounted(){

    }
}
</script>

<style>

</style>
